import {AfterViewInit, Component, inject, OnInit} from '@angular/core';
import {ProgressBarModule} from 'primeng/progressbar';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import SpecificWindowUiComponent from '../specific-window-ui/specific-window-ui.component';
import {OpenBankingService} from "@compiere-ws/services/openbanking/open-banking.service";
import {TranslatePipe} from "@ngx-translate/core";
import ButtonUiComponent from "@iupics-components/standard/fields/button-ui/button-ui.component";
import {NgClass} from "@angular/common";
import {DynamicContainerDirective} from "@iupics-util/directives/dynamic-container.directive";
import {IupicsMessage} from "@iupics-manager/models/iupics-message";

@Component({
    selector: 'iu-open-banking-window-ui',
    templateUrl: './open-banking-window-ui.component.html',
    styleUrls: ['./open-banking-window-ui.component.scss'],
    standalone: true,
    imports: [ProgressBarModule, ScrollPanelModule, TranslatePipe, ButtonUiComponent, NgClass, DynamicContainerDirective],
})
export default class OpenBankingWindowUiComponent extends SpecificWindowUiComponent implements OnInit, AfterViewInit {
    readonly #openBankingService = inject(OpenBankingService);
    needUpdate = false;

    ngOnInit() {
        super.ngOnInit();
        const endDate = this.getFormStoreData("EndDate", null);
        this.needUpdate = this?.dataStore?.data['AuthGranting']?.id == 'G'
        if (!this.needUpdate && endDate) {
            const ts = new Date(endDate).getTime(); // Convert to milliseconds
            const currentTime = Date.now();
            this.needUpdate = ts < currentTime;
        }
        if(this.needUpdate){
            this.manageAccess();
        }
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    manageAccess() {
        const sub = this.#openBankingService.openBankingLinkUrl(this.dataStore.data["Z_BankAccount_Api_Connection_ID"]).subscribe((url) => {
            window.location.href = url;
            sub.unsubscribe();
        });
    }

    syncTransactions() {
        const sub = this.#openBankingService.syncTransactions(this.getFormStoreData("Z_BankAccount_Api_Connection_ID"),this.getFormStoreData("C_BankAccount_ID",{id:0}).id).subscribe((syncronized) => {
            if (syncronized) {
                this.messageManager.newMessage(
                    new IupicsMessage(
                        this.translateService.instant('generic.success'),
                        this.translateService.instant('specificWindow.openBanking.syncronized'),
                        'success'
                    )
                );
            } else {
                this.messageManager.newMessage(
                    new IupicsMessage(
                        this.translateService.instant('generic.error'),
                        this.translateService.instant('specificWindow.openBanking.not_syncronized'),
                        'error'
                    )
                );
            }
            sub.unsubscribe()
        });
    }

    testConnection() {
        const sub = this.#openBankingService.testConnection(this.dataStore.data["Z_BankAccount_Api_Connection_ID"]).subscribe((connected) => {
            if (connected) {
                this.messageManager.newMessage(
                    new IupicsMessage(
                        this.translateService.instant('generic.success'),
                        this.translateService.instant('specificWindow.openBanking.connected'),
                        'success'
                    )
                );
            } else {
                this.messageManager.newMessage(
                    new IupicsMessage(
                        this.translateService.instant('generic.error'),
                        this.translateService.instant('specificWindow.openBanking.not_connected'),
                        'error'
                    )
                );
            }
            sub.unsubscribe()
        });
    }
}
